import React, { useState } from 'react';
import { industries } from '../data/mockData';

const IndustryCard = ({ industry, isActive, onHover }) => {
  return (
    <div
      className="relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 h-[450px] group"
      onMouseEnter={() => onHover(industry.id)}
      onMouseLeave={() => onHover(null)}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={industry.image}
          alt={industry.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>

      {/* Gradient Overlay */}
      <div className={`absolute inset-0 bg-gradient-to-t ${industry.color} transition-opacity duration-300`} />

      {/* Content */}
      <div className="absolute inset-0 p-6 flex flex-col justify-end">
        <h3 className="text-white text-xl font-bold mb-2 transition-all duration-300">
          {industry.name}
        </h3>
        
        {/* Description - shows on hover */}
        <div className={`overflow-hidden transition-all duration-500 ${isActive ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}>
          <p className="text-white/90 text-sm leading-relaxed mt-2">
            {industry.description}
          </p>
        </div>
      </div>
    </div>
  );
};

const IndustriesSection = () => {
  const [activeIndustry, setActiveIndustry] = useState(null);

  return (
    <section className="relative bg-gradient-to-b from-blue-200 via-blue-100 to-slate-100 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <span className="text-gray-600 font-medium tracking-wide italic">
              You Choose. We Deliver.
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
            Industries We Serve
          </h2>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry) => (
            <IndustryCard
              key={industry.id}
              industry={industry}
              isActive={activeIndustry === industry.id}
              onHover={setActiveIndustry}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
